import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';
import { FeatureTestUserVariant, FeatureTestVariant } from '~/types/FeatureTest';

export type FeatureTestsState = {
  testVariants: FeatureTestUserVariant[];
  testVariantByFeature: { [testName: string]: FeatureTestVariant };
  isLoading: boolean;
};

const initialState: FeatureTestsState = {
  testVariants: [],
  testVariantByFeature: {},
  isLoading: true,
};

function featureTestsReducer(state: FeatureTestsState = initialState, action: ActionTypes) {
  switch (action.type) {
    case ActionKeys.FETCH_AB_TEST_FEATURES:
      return {
        ...state,
        isLoading: true,
      };
    case ActionKeys.FETCH_AB_TEST_FEATURES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        testVariants: action.payload.featureTestUserVariants,
        testVariantByFeature: action.payload.featureTestUserVariants.reduce((map, variant) => {
          return {
            ...map,
            [variant.featureTest.name]: variant.featureTestVariant,
          };
        }, {}),
      };
    case ActionKeys.ROLL_FEATURE_TEST_DICE_SUCCESS:
    case ActionKeys.FEATURE_TEST_ASSIGN_SUCCESS:
      const { featureTestUserVariant } = action.payload;
      return {
        ...state,
        testVariants: [...state.testVariants, featureTestUserVariant],
        testVariantByFeature: {
          ...state.testVariantByFeature,
          [featureTestUserVariant.featureTest.name]: {
            name: featureTestUserVariant.featureTestVariant.name,
          },
        },
      };
    default:
      return state;
  }
}

export default featureTestsReducer;
